import ApiBase from 'Services/Api/ApiBase';

class ServiceUserMedications extends ApiBase {
    route = '/service-users/medications';
};

export default new ServiceUserMedications();